// extracted by mini-css-extract-plugin
export var label = "_d6-5";
export var slideContainer = "_d6-0";
export var slider = "_d6-1";
export var sliderLg = "_d6-4";
export var sliderMd = "_d6-3";
export var sliderSm = "_d6-2";